import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { useCheckbox } from "@website/ui/checkbox/checkbox.hook";
import styles from "@website/ui/checkbox/checkbox.module.scss";
import { CheckboxPropertiesType } from "@website/ui/checkbox/checkbox.types";
import { FC } from "react";
export const Checkbox: FC<CheckboxPropertiesType> = properties => {
  const $ = _c(30);
  const {
    inputProps
  } = useCheckbox(properties);
  const {
    className,
    wrapperClassName,
    color,
    disabled,
    label,
    error,
    helperText,
    title
  } = properties;
  const t0 = `${styles.checkbox} ${disabled ? styles.disabled : ""} ${className ?? ""} ${error ? styles.error : ""}`;
  let t1;
  if ($[0] !== inputProps) {
    t1 = <input {...inputProps} className={styles["checkbox-input"]} />;
    $[0] = inputProps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MaterialIcon className={`${styles.icon} ${styles["checkbox-outline-icon"]}`} name="check_box_outline_blank" variant="fill" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `${styles.icon} ${styles["checkbox-icon"]} ${styles[color || "primary"]}`;
  let t4;
  if ($[3] !== t3) {
    t4 = <MaterialIcon className={t3} name="check_box" variant="fill" />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = `${styles.icon} ${styles["checkbox-indeterminate-icon"]} ${styles[color || "primary"]}`;
  let t6;
  if ($[5] !== t5) {
    t6 = <MaterialIcon className={t5} name="indeterminate_check_box" variant="fill" />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = `${styles["checkbox-ripple"]} ${styles[color || "primary"]}`;
  let t8;
  if ($[7] !== t7) {
    t8 = <span className={t7} />;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t4 || $[10] !== t6 || $[11] !== t8) {
    t9 = <span className={styles["checkbox-box"]}>{t2}{t4}{t6}{t8}</span>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = `${styles["checkbox-label"]} ${disabled ? styles.disabled : ""} min-w-0`;
  const t11 = !label;
  let t12;
  if ($[13] !== label || $[14] !== t10 || $[15] !== t11) {
    t12 = <span className={t10} hidden={t11}>{label}</span>;
    $[13] = label;
    $[14] = t10;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== error || $[18] !== t0 || $[19] !== t1 || $[20] !== t12 || $[21] !== t9) {
    t13 = <label className={t0} data-error={error}>{t1}{t9}{t12}</label>;
    $[17] = error;
    $[18] = t0;
    $[19] = t1;
    $[20] = t12;
    $[21] = t9;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== helperText) {
    t14 = helperText ? <div className={styles["helper-text"]}>{helperText}</div> : null;
    $[23] = helperText;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t13 || $[26] !== t14 || $[27] !== title || $[28] !== wrapperClassName) {
    t15 = <div className={wrapperClassName} title={title}>{t13}{t14}</div>;
    $[25] = t13;
    $[26] = t14;
    $[27] = title;
    $[28] = wrapperClassName;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  return t15;
};